import { ApplicationConfig } from '@angular/core';
import { initializeApiRewriteInterceptors, initializeTheme } from 'app-shell-data';
import { IdServerConnectionError } from 'authentication-data';
import { AppEnvironment } from 'config-data';
import { bootstrapAuthentication } from './bootstrapAuthentication';
import { InvalidSessionError, MissingSessionError } from './errors';

export async function initializeApplication(env: AppEnvironment, cfg: ApplicationConfig) {
  try {
    const apiRewrites = env.apiRewrites ?? {};
    initializeApiRewriteInterceptors(apiRewrites, cfg, env);
    initializeTheme(env);
    await bootstrapAuthentication(env.auth, cfg);
  } catch (err) {
    if (err instanceof IdServerConnectionError) {
      document.body.classList.add('fatal-error');
      document.body.classList.add('id-server-connection-error');
    } else if (err instanceof InvalidSessionError) {
      document.body.classList.add('fatal-error');
      document.body.classList.add('invalid-session-error');
      document.querySelector('body.fatal-error .error h2')!.textContent = `Invalid Session '${err.sessionId}'`;
      document.querySelector('body.fatal-error .error p')!.textContent = err.message ? `Error ${err.status}: ${err.message}` : ``;
    } else if (err instanceof MissingSessionError) {
      document.body.classList.add('fatal-error');
      document.body.classList.add('missing-session-error');
      document.querySelector('body.fatal-error .error h2')!.textContent = 'Missing Session Error';
      document.querySelector('body.fatal-error .error p')!.textContent = `"${err.message}"`;
    }
    throw err;
  }
}
